
/**
 * 模拟 TEAMS 对象上的方法
 * @param teamsObj 
 */
export default function mockTEAMS () {
  if (!window.TEAMS) return;
  window.TEAMS.isDisplayModule = window.TEAMS.isDisplayModule || ((module: string) => {
    return !!(window.TEAMS.displayModules && window.TEAMS.displayModules.length > 0 && window.TEAMS.displayModules.includes(module));
  })
}
